import { BaseService } from "mrb/core";
import { UploadedContentApiRouteService } from "common/services";

class UploadedContentService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new UploadedContentApiRouteService());
    }

    find(params, abortSignal = null) {
        const url = this.routeService.find(params);
        return this.apiClient.get(url, null, abortSignal);
    }

    getSessions(params, abortSignal = null) {
        return this.apiClient.get(this.routeService.sessions(params), null, abortSignal);
    }

    getFilterOptions(abortSignal = null) {
        const url = this.routeService.getFilterOptions();
        return this.apiClient.get(url, null, abortSignal);
    }

    getDownloadUrls(keys, abortSignal = null) {
        const url = this.routeService.getDownloadUrls();
        const data = { keys };
        return this.apiClient.post(url, data, null, abortSignal);
    }

    getSessionDescription(sessionId, abortSignal = null) {
        return this.apiClient.get(this.routeService.getSessionDescription(sessionId), null, abortSignal);
    }
}

export default UploadedContentService;
